export const createSum = ({ sum }) =>
  sum ? `${(sum / 100).toFixed(2)} ₽` : '';
